import { Building2 } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { RequestLayout } from '@/components/layout/RequestLayout';
import { SurveyFormRenderer } from '@/components/registration/SurveyFormRenderer';
import { useLocalization } from '@/contexts/LocalizationContext';

function ProviderRegistrationContent() {
  const { t } = useLocalization();

  return (
    <div className="space-y-6">
      <Card className="shadow-lg">
        <CardHeader className="space-y-3 text-center pb-8">
          <div className="flex justify-center mb-4">
            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
              <Building2 className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl sm:text-3xl font-bold">
            {t('providerRegistration.title')}
          </CardTitle>
          <CardDescription className="text-base">
            {t('providerRegistration.subtitle')}
          </CardDescription>
        </CardHeader>
      </Card>

      <SurveyFormRenderer profileType="company" />
    </div>
  );
}

export function ProviderRegistrationPage() {
  return (
    <RequestLayout>
      <ProviderRegistrationContent />
    </RequestLayout>
  );
}
